import { UtilsService } from '../../services/utils.service';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { EventResponseEvent } from 'src/app/types/event-response.type';
import {
  CalendarDateFormatter,
  CalendarEvent,
  CalendarMonthViewDay,
  CalendarView,
} from 'angular-calendar';
import { CustomDateFormatter } from './custom-data-formatter.provider';
import { isSameDay } from 'date-fns';
import { formatDateLong } from '../../modules/search/util/date-formatting.util';

@Component({
  selector: 'app-my-calendar-events',
  templateUrl: './my-calendar-events.component.html',
  styleUrls: ['./my-calendar-events.component.scss'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
})
export class MyCalendarEventsComponent implements OnChanges {
  public viewDate: Date | undefined;

  @Input() date: Date;

  @Input() events: EventResponseEvent[];

  public myEvents: CalendarEvent[] = [];

  public view: CalendarView = CalendarView.Month;

  public CalendarView = CalendarView;

  get viewDateFormatted(): string {
    return (
      formatDateLong(UtilsService.dateToNgbDateStruct(this.date), {
        removeYearIfCurrent: true,
      }) ?? ''
    );
  }

  @Output() dayClicked = new EventEmitter();

  public handleDayClicked({ date }: { date: Date }): void {
    this.viewDate = date;
    this.dayClicked.emit(date);
  }

  public activeDayIsOpen(date: Date | undefined): boolean {
    return Boolean(date && isSameDay(this.date, date));
  }

  ngOnChanges(): void {
    this.viewDate = this.date;

    this.myEvents = this.events.map((event) => ({
      id: event.event_id,
      title: event.event_name,
      start: UtilsService.adjustDateForTimezone(event.event_start),
    }));
  }

  beforeMonthViewRender({
    body: calendar,
  }: {
    body: CalendarMonthViewDay[];
  }): void {
    calendar.forEach((day) => {
      day.badgeTotal = day.events.length > 0 ? 1 : 0;
      day.events = [];
    });
  }

  selectToday(): void {
    this.handleDayClicked({ date: new Date() });
  }
}
